export default __webpack_public_path__ + "static/cloud-2-84252b6f5587f220dc86acfa88b1f632.png";